import Yup from "../../Yup";

const TwoFASchema = Yup.object().shape({
  // NOTE: existing passwords are 6 chars longer, but we are enforcing a new min-length of 8
  password: Yup.string().min(6).max(128).required(),
  verification: Yup.string().min(6).max(128).required(),
});

export default TwoFASchema;
